module.exports = __webpack_public_path__ + "img/logo_mlodzi_dorosli.png";